import FuseUtils from '@fuse/utils';
import AppContext from 'app/AppContext';
import { useContext, useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { matchRoutes, useLocation, useNavigate } from 'react-router-dom';

const FuseAuthorization = ({ children }) => {
	const location = useLocation();
	const navigate = useNavigate();
	const userRole = useSelector(({ auth }) => auth.user.role);
	const routes = useContext(AppContext).routes;
	const [accessGranted, setAccessGranted] = useState(true);

	const redirectRoute = () => {
		const { pathname } = location;

		if (!userRole || userRole.length === 0) {
			navigate('/login', { state: { redirectUrl: pathname } });
		} else if (userRole[0] === 'product_owner') {
			navigate('/dashboard');
		} else {
			navigate('/login');
		}
	};

	useEffect(() => {
		const { pathname } = location;

		const matched = matchRoutes(routes, pathname)?.[0];

		if (!matched || matched.route.path === '*') {
			setAccessGranted(false);
			redirectRoute();
		} else {
			const newAccessGranted = FuseUtils.hasPermission(matched.route.auth, userRole);
			setAccessGranted(newAccessGranted);
			if (!newAccessGranted) {
				redirectRoute();
			}
		}
	}, [location, userRole, routes]);

	return accessGranted ? children : null;
};

export default FuseAuthorization;
